import {createAction, createSlice} from '@reduxjs/toolkit';

export const policyUploadInitialState = {
  policyUploadDetails: {
    divisions: [],
    roles: [],
    policyTypes: [],
  },
  isPolicyUploading: false
};

export const createPolicyUploadDataCreator = createAction<any>(
  'CREATE_POLICY_UPLOAD_DATA',
);
export const createPolicyUploadDataCreatorTypeName = createPolicyUploadDataCreator(
  {},
).type;

export const fetchDivisionsCreator = createAction(
  'POLICY_UPLOAD_HANDLER/FETCH_DIVISION_DATA',
);
export const fetchDivisionsCreatorTypeName = fetchDivisionsCreator().type;

export const fetchAllRolesCreator = createAction(
  'POLICY_UPLOAD_HANDLER/FETCH_ALL_ROLES',
)

export const fetchAllRolesCreatorTypeName = fetchAllRolesCreator().type;

export const fetchPolicyTypesCreator = createAction(
  'POLICY_UPLOAD_HANDLER/FETCH_POLICY_TYPES'
);
export const fetchPolicyTypesCreatorTypeName = fetchPolicyTypesCreator().type;

const policyUploadStateHandler = createSlice({
  name: 'POLICY_UPLOAD_HANDLER',
  initialState: policyUploadInitialState,
  reducers: {
    setDivisions: (prevState, action) => {
      const policyUploadDetails = prevState.policyUploadDetails;
      return {
        ...prevState,
        policyUploadDetails: {
          ...policyUploadDetails,
          divisions: action.payload,
        },
      };
    },
    setRoles: (prevState, action) => {
      const policyUploadDetails = prevState.policyUploadDetails;
      return {
        ...prevState,
        policyUploadDetails: {
          ...policyUploadDetails,
          roles: action.payload,
        },
      };
    },
    setPolicyTypes: (prevState, action) => {
      const policyUploadDetails = prevState.policyUploadDetails;
      return {
        ...prevState,
        policyUploadDetails: {
          ...policyUploadDetails,
          policyTypes: action.payload,
        }
      };
    },
    setPolicyTypeId: (prevState, action) => {
      const policyUploadDetails = prevState.policyUploadDetails;
      return {
        ...prevState,
        policyUploadDetails: {
          ...policyUploadDetails,
          policyTypeId: action.payload,
        },
      };
    },
    setDivisionData: (prevState, action) => {
      return {
        ...prevState,
        divisions: action.payload,
      };
    },
    setDivisionError: (prevState) => {
      return {
        ...prevState,
        divisions: [],
      };
    },
    setRolesError: (prevState) => {
      return {
        ...prevState,
        roles: [],
      };
    },
    setIsPolicyUploading: (prevState, action) => {
      return {
        ...prevState,
        isPolicyUploading: action.payload,
      };
    }
  },
});

export const policyUploadStateActions = policyUploadStateHandler.actions;
export const policyUploadStateReducer = policyUploadStateHandler.reducer;
